import useNavigatorTypeahead from "../../../../../../datahooks/useNavigatorTypeahead";

import type { JSX } from "react";
import type {
  NavigatorFilters,
  SelectedNavigatorFilters,
} from "../../../../../../types";

export default function TypeaheadValues({
  query,
  typeaheadType,
  selectedValues,
  returnedValues,
  renderSelectionComponent,
}: {
  query?: string;
  typeaheadType: string;
  selectedValues: SelectedNavigatorFilters[number]["values"];
  returnedValues: NavigatorFilters[number]["values"];
  renderSelectionComponent: (
    options: NavigatorFilters[number]["values"],
  ) => JSX.Element;
}) {
  const { typeaheadOptions } = useNavigatorTypeahead({
    type: typeaheadType,
    query,
  });

  let selectionOptions: NavigatorFilters[number]["values"] = [
    ...(query ? [] : returnedValues),
  ];
  if (typeaheadOptions) {
    selectionOptions.push(
      ...typeaheadOptions.filter(
        ({ id }) => !returnedValues.find((value) => value.id === id),
      ),
    );
  }
  selectionOptions = selectionOptions.filter(
    ({ id }) => !selectedValues.find((value) => value.id === id),
  );
  selectionOptions = [
    ...selectionOptions.filter(({ id }) => !id.includes(":salesList")),
    ...selectionOptions.filter(({ id }) => id.includes(":salesList")),
  ];

  return renderSelectionComponent(selectionOptions);
}
